import React from 'react'
import { Modal } from 'react-bootstrap'
import ContactUsAzureSection from 'components/ContactUsAzure'

const ContactBlogModal = (props) => {
  const { show, onClose } = props
  return (
    <Modal
      className="cmn_modal"
      size="xl"
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="p-0" />
      <Modal.Body className="p-0">
        <div className="azure-model-sec-main">
          <div className="row">
            <div className="col-lg-5">
              <div className="p-xl-5 p-3 conne_bg_left d-flex flex-column align-items-start justify-content-between">
                <div>
                  <div className="title48px700 text-white pb-2">
                    Connect with us
                  </div>
                  <div className="pb-4 text-white opacity-75 fw-400">
                    Please fill in the form and we guarantee to get back to you
                    within a business day.
                  </div>
                </div>
                <div>
                  <div className="d-flex align-items-center pb-2">
                    <svg
                      className="rvt-icon rat-icon-mail text-white"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.25 6.25H23.75C24.819 6.25 25.7312 6.92089 26.0887 7.86458C25.9714 7.88591 25.8565 7.93102 25.751 8.00135L15.0002 15.1685L4.24942 8.00135C4.14382 7.93095 4.02876 7.88581 3.91135 7.86451C4.26884 6.92086 5.18108 6.25 6.25 6.25ZM3.75 9.83173V21.25C3.75 22.6307 4.86929 23.75 6.25 23.75H23.75C25.1307 23.75 26.25 22.6307 26.25 21.25V9.83199L15.4994 16.999C15.1971 17.2006 14.8033 17.2006 14.501 16.999L3.75 9.83173Z"
                        fill="currentColor"
                      />
                    </svg>
                    <a
                      href="mailto:sales@webcluesinfotech.com"
                      className="hover-text-orange me-4 ms-2 text-white text-decoration-none"
                    >
                      sales@webcluesinfotech.com
                    </a>
                  </div>
                  <div className="d-flex align-items-center pb-4">
                    <svg
                      className="rvt-icon rat-icon-phone text-white"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.25 5H11.25L13.75 11.25L10.625 13.125C11.9637 15.8394 14.1606 18.0363 16.875 19.375L18.75 16.25L25 18.75V23.75C25 24.413 24.7366 25.0489 24.2678 25.5178C23.7989 25.9866 23.163 26.25 22.5 26.25C17.6241 25.9537 13.0252 23.8831 9.57104 20.429C6.11688 16.9748 4.04631 12.3759 3.75 7.5C3.75 6.83696 4.01339 6.20107 4.48223 5.73223C4.95107 5.26339 5.58696 5 6.25 5Z"
                        fill="currentColor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 8.75C18 8.33579 18.3358 8 18.75 8C19.612 8 20.4386 8.34241 21.0481 8.9519C21.6576 9.5614 22 10.388 22 11.25C22 11.6642 21.6642 12 21.25 12C20.8358 12 20.5 11.6642 20.5 11.25C20.5 10.7859 20.3156 10.3408 19.9874 10.0126C19.6592 9.68437 19.2141 9.5 18.75 9.5C18.3358 9.5 18 9.16421 18 8.75Z"
                        fill="currentColor"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M18 3.75C18 3.33579 18.3358 3 18.75 3C20.938 3 23.0365 3.86919 24.5836 5.41637C26.1308 6.96354 27 9.06196 27 11.25C27 11.6642 26.6642 12 26.25 12C25.8358 12 25.5 11.6642 25.5 11.25C25.5 9.45979 24.7888 7.7429 23.523 6.47703C22.2571 5.21116 20.5402 4.5 18.75 4.5C18.3358 4.5 18 4.16421 18 3.75Z"
                        fill="currentColor"
                      />
                    </svg>
                    <a
                      href="tel:+91-814-106-8282"
                      className="hover-text-orange me-4 ms-2 text-white text-decoration-none"
                    >
                      +91-814-106-8282
                    </a>
                  </div>
                </div>
                <div className="justify-content-between align-items-center pt-5 row">
                  <div className="col-auto col">
                    <div className="d-flex flex-wrap">
                      <a
                        href="https://www.linkedin.com/company/webclues-infotech"
                        rel="noreferrer"
                        target="_blank"
                        className="me-4 text-white"
                      >
                        <svg
                          className="rvt-icon rat-icon-linkedin w-25px h-25px text-white"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        />
                        <path
                          d="M7.75125 26.25H2.30906V8.72437H7.75125V26.25ZM5.02688 6.33375C3.28688 6.33375 1.875 4.89187 1.875 3.15188C1.875 2.31595 2.20707 1.51425 2.79816 0.923163C3.38925 0.332072 4.19095 0 5.02688 0C5.8628 0 6.6645 0.332072 7.25559 0.923163C7.84668 1.51425 8.17875 2.31595 8.17875 3.15188C8.17875 4.89187 6.76687 6.33375 5.02688 6.33375ZM28.1194 26.25H22.6894V17.7188C22.6894 15.6853 22.6481 13.0781 19.86 13.0781C17.0306 13.0781 16.5966 15.2869 16.5966 17.5725V26.25H11.16V8.72437H16.3791V11.115H16.455C17.1816 9.73781 18.9563 8.28469 21.6038 8.28469C27.1116 8.28469 28.1241 11.9119 28.1241 16.6228V26.25H28.1194Z"
                          fill="currentColor"
                        />
                      </a>
                      <a
                        href="https://twitter.com/Webcluesinfo"
                        rel="noreferrer"
                        target="_blank"
                        className="me-4"
                      >
                        <svg
                          className="rvt-icon rat-icon-twitter w-25px h-25px text-white"
                          width="26"
                          height="21"
                          viewBox="0 0 26 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        />
                        <path
                          d="M25.1662 2.42675C24.2407 2.83684 23.2466 3.11393 22.2014 3.23918C23.2798 2.59389 24.0866 1.57827 24.4713 0.381847C23.4581 0.98367 22.3492 1.40729 21.1928 1.63428C20.4151 0.80398 19.3851 0.25364 18.2627 0.0687093C17.1402 -0.116221 15.9881 0.074603 14.9852 0.611556C13.9823 1.14851 13.1847 2.00155 12.7163 3.03824C12.2479 4.07492 12.1348 5.23726 12.3947 6.34478C10.3417 6.24169 8.33328 5.70808 6.49984 4.77857C4.6664 3.84906 3.0489 2.54442 1.7523 0.949323C1.30896 1.71409 1.05404 2.60077 1.05404 3.54508C1.05355 4.39518 1.26289 5.23226 1.6635 5.98205C2.06411 6.73184 2.6436 7.37115 3.35055 7.84327C2.53067 7.81718 1.72889 7.59564 1.01192 7.1971V7.2636C1.01184 8.4559 1.42427 9.61151 2.17922 10.5343C2.93417 11.4572 3.98516 12.0904 5.15383 12.3265C4.39326 12.5324 3.59586 12.5627 2.82186 12.4152C3.15159 13.4411 3.79388 14.3382 4.65881 14.981C5.52373 15.6237 6.568 15.9799 7.64541 15.9996C5.81644 17.4354 3.55768 18.2142 1.23249 18.2108C0.820602 18.2109 0.409066 18.1868 0 18.1387C2.36021 19.6563 5.10766 20.4616 7.91363 20.4585C17.4122 20.4585 22.6048 12.5914 22.6048 5.76843C22.6048 5.54676 22.5993 5.32288 22.5893 5.10121C23.5993 4.37077 24.4712 3.46627 25.164 2.43008L25.1662 2.42675Z"
                          fill="currentColor"
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/WebCluesInfotechLLP/"
                        rel="noreferrer"
                        target="_blank"
                        className="me-4"
                      >
                        <svg
                          className="rvt-icon rat-icon-facebook w-25px h-25px text-white"
                          width="15"
                          height="30"
                          viewBox="0 0 15 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        />
                        <path
                          d="M3.88824 30V15.9231H0.166016V10.8548H3.88824V6.52575C3.88824 3.12396 6.08697 0 11.1533 0C13.2046 0 14.7214 0.19665 14.7214 0.19665L14.6019 4.92963C14.6019 4.92963 13.055 4.91457 11.3669 4.91457C9.53991 4.91457 9.2472 5.75652 9.2472 7.15395V10.8548H14.7471L14.5078 15.9231H9.2472V30H3.88824Z"
                          fill="currentColor"
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/webcluesinfotech/"
                        rel="noreferrer"
                        target="_blank"
                        className="me-4"
                      >
                        <svg
                          className="rvt-icon rat-icon-instagram w-25px h-25px text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                        />
                        <path
                          id="Group"
                          d="M15.747,0c-4.071,0-4.582.019-6.182.09a11.053,11.053,0,0,0-3.643.7A7.344,7.344,0,0,0,3.265,2.518,7.363,7.363,0,0,0,1.535,5.175a10.987,10.987,0,0,0-.7,3.637C.766,10.416.747,10.926.747,15s.019,4.583.09,6.182a11.05,11.05,0,0,0,.7,3.641A7.679,7.679,0,0,0,5.92,29.212a11.013,11.013,0,0,0,3.641.7c1.6.071,2.111.09,6.186.09s4.582-.019,6.184-.09a11.074,11.074,0,0,0,3.643-.7,7.68,7.68,0,0,0,4.386-4.387,11.1,11.1,0,0,0,.7-3.641c.071-1.6.09-2.109.09-6.184s-.019-4.584-.09-6.186a11.089,11.089,0,0,0-.7-3.639,7.361,7.361,0,0,0-1.731-2.657A7.333,7.333,0,0,0,25.572.788a11.035,11.035,0,0,0-3.643-.7C20.328.019,19.82,0,15.743,0h0ZM14.4,2.7h1.346c4.005,0,4.479.013,6.06.086a8.313,8.313,0,0,1,2.786.516A4.654,4.654,0,0,1,26.32,4.429a4.633,4.633,0,0,1,1.121,1.725,8.239,8.239,0,0,1,.516,2.784c.073,1.581.088,2.055.088,6.058s-.015,4.479-.088,6.06a8.3,8.3,0,0,1-.516,2.784,4.972,4.972,0,0,1-2.848,2.844,8.251,8.251,0,0,1-2.784.517c-1.581.071-2.055.088-6.06.088s-4.481-.017-6.062-.088A8.284,8.284,0,0,1,6.9,26.685a4.645,4.645,0,0,1-1.725-1.121,4.649,4.649,0,0,1-1.125-1.725,8.286,8.286,0,0,1-.516-2.784c-.071-1.581-.086-2.055-.086-6.062s.015-4.477.086-6.058a8.3,8.3,0,0,1,.518-2.786A4.654,4.654,0,0,1,5.178,4.423,4.634,4.634,0,0,1,6.9,3.3a8.285,8.285,0,0,1,2.784-.517c1.384-.064,1.92-.082,4.716-.084v0Zm9.352,2.49a1.8,1.8,0,1,0,1.273.527,1.8,1.8,0,0,0-1.273-.527ZM15.749,7.3a7.7,7.7,0,1,0,5.37,2.3,7.7,7.7,0,0,0-5.37-2.3Zm0,2.7a5,5,0,1,1-3.536,1.465A5,5,0,0,1,15.749,10Z"
                          transform="translate(-0.747)"
                          fill="currentColor"
                        />
                      </a>
                      {/* <a
                        href="https://www.behance.net/webcluesin486f/"
                        rel="noreferrer"
                        target="_blank"
                      >
                        <svg
                          className="rvt-icon rat-icon-be w-25px h-25px text-white"
                          width="31"
                          height="19"
                          viewBox="0 0 31 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        />
                        <path
                          d="M20.3343 1.24578H27.8202V3.06191H20.3343V1.24578ZM12.8334 8.43152C14.4882 7.63977 15.3549 6.43527 15.3549 4.57411C15.3549 0.893058 12.6157 0 9.45251 0H0.74707V18.4765H9.69641C13.051 18.4765 16.1992 16.863 16.1992 13.1107C16.1992 10.7917 15.1035 9.07692 12.8334 8.43152ZM4.80711 3.15197H8.61574C10.0829 3.15197 11.4 3.56098 11.4 5.26454C11.4 6.83302 10.3756 7.46341 8.92343 7.46341H4.80711V3.15197ZM9.14107 15.3396H4.80336V10.2514H9.22737C11.0135 10.2514 12.1429 10.9981 12.1429 12.8893C12.1429 14.7505 10.7959 15.3396 9.14107 15.3396ZM30.7471 11.9812C30.7471 8.02251 28.4319 4.7242 24.2443 4.7242C20.173 4.7242 17.4037 7.78987 17.4037 11.8086C17.4037 15.9737 20.0266 18.833 24.2443 18.833C27.4375 18.833 29.505 17.3959 30.4994 14.3302H27.2611C26.9084 15.4747 25.475 16.075 24.3606 16.075C22.2067 16.075 21.081 14.8143 21.081 12.6717H30.7208C30.7321 12.4503 30.7471 12.2176 30.7471 11.9812ZM21.081 10.3527C21.1974 8.59287 22.3718 7.49343 24.1279 7.49343C25.9741 7.49343 26.8972 8.57786 27.0585 10.3527H21.081Z"
                          fill="currentColor"
                        />
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="azure_contantus">
                <ContactUsAzureSection
                  data={{
                    title: 'Connect with us',
                    subTitle: 'For Project Inquiries',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ContactBlogModal
